import React from "react";
import { Link } from "react-router-dom";
import "./Attribution.css";
import "../utils/Style/Style.css";
const Article = () => {
  return (
    <div>
      <div id="thething" className="mt-[-0.5rem]">
        <h2 id="Team">Team </h2>
        <hr class="dividergeneral mb-5" />
        <h4>Florian Aubert</h4>
        <p>
          The mind behind the project, rebelling against the concept of
          "sleeping hours" his omnipresence in the wetlab has been of immense
          value.
        </p>
        <h4>Charles Boissier</h4>
        <p>
          The mind behind the wiki. His expertise in computer science and
          patience gave us the necessary tools to make our vision of it come
          true. Even without the usual biological background, he has shown great
          interest in the wetlab, participating whenever possible.
        </p>
        <h4>Charlotte Coulon</h4>
        <p>
          Charlotte work simply cannot be overstated. She has been one of the 3
          pillars of the wetlab while also taking part in the graphical team and
          human practices. She was also a great help with the BSGV project.
        </p>
        <h4>Timothé Dufour</h4>
        <p>
          Timothé, or as we like to call him "DJ Tee", was a great talent both
          in the wet and dry lab. His social skills were invaluable for events,
          sponsorship and social media management. He has also contributed
          extensively to the wiki coding.
        </p>
        <h4>Maud Faivre D'Arcier</h4>
        <p>
          Maud can be described as the face of our project. Aside from being in
          the wet and dry lab, she has been working on merch, sponsors, social
          medias and has also contributed to the wiki.
        </p>
        <h4>Lucie Huamani-Cantrelle</h4>
        <p>
          One if not the main artist behind the visual identity of the project.
          Her tremendous work in both the graphical team and the wiki falls
          nothing short of fantastic. She is behind the camera for photos and
          videos and is also in charge of video editing.
        </p>
        <h4>Matthis Lugnier</h4>
        <p>
          The last of our wetlab trio. Working relentlessly on the project,
          Matthis has been an example of tenacity, patience and ingenuity for
          the rest of the team. He is also responsible of the BSGV project.
        </p>
        <h4>Maxime Nourry</h4>
        <p>
          One of the teams polymaths, Maxime lead the main video game
          development while also helping the team in a various areas such as
          remaking broken lab parts, helping on the wiki and being 48C
          photograph.
        </p>
        <h4>Cassandre Pitz</h4>
        <p>
          Member of the graphical and video team. Her work provided the visuals
          and animations necessary to transmit and share our acquired knowledge.
          She has also taken part in the human practices and the wetlab during
          the entirety of the project.
        </p>
        <h4>Eva Quinto</h4>
        <p>
          Always busy, Eva has been an essential member regarding
          administration, human practices and sponsorship finding. Her
          creativity was of great help during the making of the video game and
          her bio student background was of great use during SpaC experiments.
        </p>
        <h4>Jade Therras</h4>
        <p>
          The lead programmer behind most of the minigames, she has shown great
          interest in the dry lab aspect while giving important support in the
          wetlab.
        </p>
        <h4>Leonardo Tredici</h4>
        <p>
          The jack of all trades of the team, he has been of great support in
          both the wet and dry lab. He has participated in the coding of
          mini-games, website coding, recruited sponsors and has initiated the
          process of the Horizontal Gene Transfer part.
        </p>

        <h2 id="Supervisors" className="mt-20">
          Supervisors
        </h2>
        <hr class="dividergeneral" />
        <h4>Pr. Brian McCabe</h4>
        <p>
          The main team investigator. His experience with iGEM was of great help
          during both the choosing of our project and its realisation. From
          small advices about wiki writting to his network with other labs, Pr.
          McCabe earned without any doubt the title of "most important asset in
          our toolbox".
        </p>
        <h4>Hannah Schede </h4>
        <p>Our main contact regarding data analysis and dry lab in general.</p>
        <h4>Keshav Jha</h4>
        <p>
          Our main wetlab support. During the entirety of the project, Keshav
          always found time to give us advices. We simply couldn't have make it
          without him.
        </p>
        <h4>Rebecca Smith</h4>
        <p>
          Our team coordinator and ressource manager. She helped us with both
          budget and project planning while also giving support in the wetlab.
        </p>
        <h2 id="External-People" className="mt-20">
          External people
        </h2>
        <h3 id="lab" className="mt-10">
          Laboratory infrastructure and supply
        </h3>
        <hr class="dividergeneral" />
        <h4>Microbial Mechanics Lab</h4>
        <p>
          We want to express our gratitude to the <b>Microbial Mechanics Lab</b>{" "}
          led by <b>Alexandre Persat</b> at EPFL for their invaluable support
          throughout our project. They not only provided us with valuable
          theoretical advice but also assisted us with the mucus binding assay.
          We are particularly grateful to<b> Dr Sofya Mikhaleva</b> who
          generously shared her expertise and time to cultivate mucus-producing
          intestinal cancer cells on permeable supports and quantify our
          bacterial abilities to bind to intestinal mucus. The Persat group
          specializes in studying how bacteria respond to mechanical forces in
          their physical surroundings. They specifically focus on{" "}
          <b>Bacterial Mechanosensing</b>, <b>Biofilm Morphomechanics</b> and{" "}
          <b>Mechanobiology of Infection</b>. Their research of bacterial
          mechanobiology could in the future be used to develop alternative
          therapeutic strategies to combat, among others, the growing challenge
          of antibiotic resistance. Beyond their cutting-edge work, such as the
          mucus-on-a-chip technology, we were genuinely impressed by the warm
          and supportive atmosphere within the Persat group. They created an
          environment that was not only conducive to research but also welcoming
          and encouraging.
        </p>
        <h4>Evelyne Ruchti</h4>
        <p>
          McCabe lab correspondant, She helped us to prepare and to conduct our
          cloning.
        </p>
        <h4>Stephane Marquis and Holliger Christof</h4>
        <p>
          They provided and help us with the spectrophotometer, essential to our
          late testings.
        </p>
        <h4>Dominic Dabrowski</h4>
        <p>
          He told us about Cadmium intoxication in the US as well as provided us
          with figures about contaminations.
        </p>

        <h3 id="education" className="mt-10">
          Education and Communication
        </h3>
        <hr class="dividergeneral" />
        <h4>Suzanne Peters</h4>
        <p>
          Suzanne Peters was of great help for the BSGV organisation, she
          transmited our idea to all the professors in the Vaud State and also
          advised us about how to best teach students depending on their age
          group.
        </p>
        <h4>EPFL Mediacom team</h4>
        <p>
          The equipment they lended made all of our videos possible and we would
          like to thank them for that.
        </p>
        <h3 id="HP" className="mt-10 ">
          Human Practices
        </h3>
        <hr class="dividergeneral" />
        <h4>Prof. Murray McBride</h4>
        <p>
          Prof. Murray McBride was of great use in understanding how cadmium get
          absorbed in soils.
        </p>
        <h4>Prof. Catherine Jumarie</h4>
        <p>
          She helped us understand the long term impact of cadmium on the human
          body.
        </p>
        <h4>Dr. Enrico Fiaccadori</h4>
        <p>
          He gave us a better understanding about how and who our product could
          help.
        </p>
        <h4>Sarah Naili</h4>
        <p>
          Sarah Naili provided great insight about the regulations regarding
          probiotics.
        </p>
        <h4>Louis Nel</h4>
        <p>
          He gave us a better understanding about how our product could be used
          in the industry.
        </p>
        <h3 id="safety" className="mt-10">
          Safety protocols
        </h3>
        <hr class="dividergeneral" />
        <h4>Dr. Didier Perret and Karl Perron</h4>
        <p>
          Dr. Didier Perret and Karl Perron gave us a lot of advices about how
          to work with cadmium, Those were proven very usefull{" "}
        </p>
        <h4>EPFL OHS</h4>
        <p>
          Our university lab safety office, we would like to thanks{" "}
          <b>Benjamin Uster</b> who advised us about the gears and precautions
          required when working with cadmium.
        </p>
        <h3 id="other teams" className="mt-10">
          Collaborations
        </h3>
        <hr class="dividergeneral" />
        <p>
          The team of <b>GU-Frankfurt</b> for their advices regarding cadmium
          handling, <b>Uzurich</b> for hosting and speaking at the Swiss Synbio
          Meet-up, along with <b>UNILausanne</b>. The <b>Münster team</b> for
          organising the unforgivable Münster Junior Jam and last but not least
          the <b> Thessaloniki Team</b>
          for their collaboration on the game.
        </p>

        <h3 id="financial" className="mt-10">
          Financial facilitator
        </h3>
        <hr class="dividergeneral" />

        <h4>Sophie Barret</h4>
        <p>
          The administrative assistant of Pr. McCabe group, she managed the
          financial aspect of our team, the travelling expenses and the
          reimbursements. We thank her for her patience, work and attitude.
        </p>
        <h3 id="unclassifiable" className="mt-10">
          The Unclassifiable
        </h3>
        <hr className="dividergeneral mb-5" />
        <h4>ChatGPT and OpenAI</h4>
        <p>
          How not to mention ChatGPT which helped us tremendously in both wiki
          coding and text writting.
        </p>

        <h4>Marcus Creus</h4>
        <p>
          CSO of Plusbiome, his insight into the market of probiotics and gmos
          was of great help in elaborating our product.
        </p>

        <h2 id="sponsors" className="mt-20">
          Sponsors
        </h2>
        <hr class="dividergeneral mb-5" />

        <p>
          Please find all our sponsors on the{" "}
          <Link to="/epfl/acknowledgements"> acknowledgement page</Link>.
        </p>

        <h2 id="attribution-form" className="mt-20">
          Form
        </h2>
        <hr class="dividergeneral mb-10" />
        <iframe
          src="https://attributions.igem.org?team=epfl&year=2023"
          id="igem-attribution-form"
          title="Attribution Form"
          style={{
            width: "100%",
            border: "solid 7px",
            borderRadius: "2%",
            borderColor: "var(--violet-pale)",
          }}
          className="h-screen mb-20"
        />
      </div>
    </div>
  );
};

export default Article;
